import { Checkbox as CheckboxComponent } from '@chakra-ui/react';
import styled from 'styled-components';

export const WrapperForm = styled.form<any>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 67.5%;

  padding: 5.125rem 5rem 0rem 5rem;

  h1 {
    font-size: 1.875rem;
    color: ${({ theme }) => theme.colors.tertiary};
  }

  .terms span {
    display: flex;
    align-items: center;
  }

  .terms a {
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
    color: #050505;
    margin-left: 0.2rem;
    margin-right: 0.2rem;
  }
`;

export const Checkbox = styled(CheckboxComponent)<any>`
  /* margin-bottom: 1rem; */

  .chakra-checkbox__control {
    box-shadow: none !important;
    border: 2px solid #333;

    height: 1rem;
    width: 1rem;

    &[data-checked] {
      border: 1px solid ${({ theme }) => theme.colors.tertiary};
      background-color: ${({ theme }) => theme.colors.tertiary};

      &:hover {
        background-color: ${({ theme }) => theme.colors.tertiary} !important;
      }
    }
  }

  .chakra-checkbox__label {
    margin-bottom: auto;
    margin-top: auto;
    margin-left: 12px;

    height: 23px;

    font-size: 14px;
    color: ${({ theme }) => theme.colors.black700};
    span {
      a {
        color: ${({ theme }) => theme.colors.black700};
      }
    }

    &[data-checked] {
      color: ${({ theme }) => theme.colors.black700};

      span {
        font-weight: bold;

        a {
          color: ${({ theme }) => theme.colors.black700};
        }
      }
    }
  }
`;
